declare const __ENABLE_MOCKS__: boolean;

export async function initMocks() {
  const urlParams = new URLSearchParams(window.location.search);
  const isMockParamSet = urlParams.get("mock") === "true";

  if (typeof window !== "undefined" && (__ENABLE_MOCKS__ || isMockParamSet)) {
    const { worker } = await import("./browser");

    // `worker.start()` returns a Promise that resolves
    // once the Service Worker is up and ready to intercept requests.
    return worker.start({
      onUnhandledRequest: "bypass", // Don't warn about unhandled requests (e.g. assets)
    });
  }
}
